// @flow

import { getFirebaseInstance } from './firebase'
import { cookiesEnabled } from '../widgets/LivePoll/helpers/cookieUtils'

import type { Vote, AuthConfig } from '../types'

export async function registerVote (vote: Vote, authConfig: AuthConfig) {
  if (!cookiesEnabled()) {
    throw new Error('Cookies are not enabled')
  }

  const credentials = await getFirebaseInstance(authConfig)
    .auth()
    .signInAnonymously()

  const pollVotesRef = getFirebaseInstance()
    .database()
    .ref('pollVotes')

  const voted = await pollVotesRef.push({
    uid: credentials.uid,
    alternativeId: vote.alternativeId,
    pollId: Number(vote.pollId),
    channelId: Number(vote.clientId)
  })
  return voted
}



// WEBPACK FOOTER //
// ./src/shared/db/registerVote.js